import React from 'react';
import { Helmet } from 'react-helmet';
import HomeCarousel from '../pages/HomeCarousel';
import Carousel from '../pages/Carousel';
import WelcomeSection from '../pages/welcomeData';
import ExperienceSection from '../pages/ExperienceSection';
import ServicesSection from '../pages/ServicesSection';
import ProjectSection from '../pages/ProjectSection';
import TestimonialSection from '../pages/TestimonialSection';
import ProductSection from '../pages/products';
import NewsSection from '../pages/NewsSection';
import OurClients from '../pages/OurClients';
import Types from '../pages/Types';


const Hero = () => {
  return (
    <div>
{/* <HomeCarousel/> */}
<Carousel/>
      <WelcomeSection/>
      <ExperienceSection/>
      <ServicesSection/>
      <ProjectSection/>
      <TestimonialSection/>
      <ProductSection/>
      <Types/>
      {/* <NewsSection/> */}
      <OurClients/>
    </div>
  );
};

export default Hero;
